export const STORY_LOADING_STATES = {
  INITIALIZING: {
    text: 'Preparing to generate your story...',
    progress: 10
  },
  GENERATING_STORY: {
    text: 'Creating your unique story...',
    progress: 30
  },
  ENHANCING_CONTENT: {
    text: 'Adding creative details and descriptions...',
    progress: 50
  },
  FORMATTING_PAGES: {
    text: 'Formatting story into pages...',
    progress: 70
  },
  FINALIZING: {
    text: 'Polishing your story for preview...',
    progress: 90
  },
  COMPLETE: {
    text: 'Your story is ready!',
    progress: 100
  }
};

export const DESIGN_LOADING_STATES = {
  CREATING_CHARACTERS: {
    text: 'Creating character descriptions...',
    progress: 25
  },
  GENERATING_PROMPTS: {
    text: 'Generating image prompts...',
    progress: 50
  },
  OPTIMIZING_LAYOUTS: {
    text: 'Optimizing page layouts...',
    progress: 75
  },
  FINALIZING: {
    text: 'Preparing design interface...',
    progress: 90
  }
};

export const PRINT_LOADING_STATES = {
  PROCESSING: {
    text: 'Processing pages...',
    progress: 25
  },
  OPTIMIZING: {
    text: 'Optimizing for print...',
    progress: 50
  },
  FINALIZING: {
    text: 'Preparing print preview...',
    progress: 90
  }
};